var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"success","icon":"el-icon-upload"},on:{"click":_vm.JumpTo}},[_vm._v(_vm._s(_vm.buttonname))])
}
var staticRenderFns = []

export { render, staticRenderFns }